import { IWeather } from '../flowers-interfaces';

/**
 * Average Monthly Weather Data for Israel.
 */
export const getWeather = (): IWeather => {

    const monthlyWeather: Record<number, IWeather> = {
        0: { temperature: 14, humidity: 65, sunlightHours: 6, monthName: 'January' },
        1: { temperature: 15, humidity: 60, sunlightHours: 7, monthName: 'February' },
        2: { temperature: 18, humidity: 55, sunlightHours: 8, monthName: 'March' },
        3: { temperature: 22, humidity: 50, sunlightHours: 9, monthName: 'April' },
        4: { temperature: 25, humidity: 45, sunlightHours: 10, monthName: 'May' },
        5: { temperature: 30, humidity: 40, sunlightHours: 11, monthName: 'June' },
        6: { temperature: 32, humidity: 35, sunlightHours: 12, monthName: 'July' },
        7: { temperature: 31, humidity: 38, sunlightHours: 11, monthName: 'August' },
        8: { temperature: 28, humidity: 45, sunlightHours: 10, monthName: 'September' },
        9: { temperature: 25, humidity: 50, sunlightHours: 9, monthName: 'October' },
        10: { temperature: 20, humidity: 55, sunlightHours: 8, monthName: 'November' },
        11: { temperature: 16, humidity: 60, sunlightHours: 7, monthName: 'December' },
    };

    const today = new Date();
    const month = today.getMonth(); // JavaScript months are 0-based (0 = January, 11 = December)
    return monthlyWeather[month];
};